import React, { useState, useEffect } from "react";
import { StandartButton } from "commons/form-controls";
import s from "./align-buttons.module.scss";

const AlignButtons = (props) => {

    const [align, setAlign] = useState(props.alignment);

    useEffect(() => {
        setAlign(props.alignment);
    }, [props]);

    const alignItems = (align) => {
        props.alignItems(align);
    }

        const controlButtons = <div className={s.AlignmentButtons}>
            <StandartButton title={props.getValue('BY_LEFT')} callback={alignItems.bind(this, 'LEFT')} background={align && align !== 'LEFT' ? 'white' : ''}/>
            <StandartButton title={props.getValue('BY_CENTER')} callback={alignItems.bind(this, 'CENTER')} background={align && align !== 'CENTER' ? 'white' : ''}/>
            <StandartButton title={props.getValue('BY_RIGHT')} callback={alignItems.bind(this, 'RIGHT')} background={align && align !== 'RIGHT' ? 'white' : ''}/>
        </div>

    return (
        <div className={s.AlignButtons}>
            { controlButtons }
        </div>
    )
}

export default AlignButtons;